import { Input } from "../../ui/Input";
export const SubscriptionForm = ({
    formData,
    handleChange,

}) =>{
    return(
        <div className="transaction-form">
                
                <Input
                        label="Subscription Plan "
                        type="text"
                        name="SubscriptionPlan"
                        value="Yearly"
                        disabled={true}
                      />
                  <Input
                        label="Renews "
                        type="text"
                        name="SubscriptionRenew"
                        value="04/07/2025"
                        disabled={true}
                      />
                </div>
    )
}